
// eslint-disable-next-line no-unused-vars
import IConfigurationService from "../interfaces/configuration_service";

import { defineComponent, inject, onBeforeMount, reactive, ref } from "vue";
// eslint-disable-next-line no-unused-vars
import IRegionFilters from "@/interfaces/region_filters";

interface IRegionSelectorOption
{
	region: string
}

export default defineComponent({
	name: "RegionFilter",
	props:{
	},
	// eslint-disable-next-line no-unused-vars
	setup(props: any, { emit })
	{
		const configurationService = inject<IConfigurationService>("configurationService");
		//const regionFilters = reactive<Array<IRegionFilters>>([]);
		const options =	reactive<Array<IRegionSelectorOption>>([]);
		const selectedOption = ref<IRegionSelectorOption>();

		if (!configurationService)
		{
			throw new Error("Configuration service not initialised");
		}

		function loadRegionFilters()
		{
			let regionFilters = configurationService?.getRegionFilters();
			if (regionFilters)
			{
				const regions = regionFilters.default.map((item) => item.region );
				for(const region of regions)
				{
					options.push({ region: region});
				}

				// if (selectedOption?.value)
				// {
				// 	selectedOption.value.region = options[0]?.region;
				// }
				
				console.log(`Region Names: ${JSON.stringify(options)}`);
			}
		}

		function changeItem(item:IRegionSelectorOption)
		{
			console.log(`Item: ${item}`)
			// selectedOption.value = item;

			// emit("region-selected", dateSelector?.toRange(item.action))
		}

		// function setOptions()
		// {
		// 	options.values = [{ region: 'blah'}];
		// 	selectedOption.value = (props.dateSelectorOptions!=null && props.dateSelectorOptions.length>0? props.dateSelectorOptions[0]:null);
		// }

		//watch(() => props.dateSelectorOptions, setOptions);
		onBeforeMount(function()
		{
			loadRegionFilters();
			// setOptions();
		});

		return {
			// t,
			options,
			selectedOption,
			changeItem
		}
	}
});
